import { render, staticRenderFns } from "./asideIconMenu.vue?vue&type=template&id=6dd2aa1b&scoped=true"
import script from "./asideIconMenu.vue?vue&type=script&lang=js"
export * from "./asideIconMenu.vue?vue&type=script&lang=js"
import style0 from "./asideIconMenu.vue?vue&type=style&index=0&id=6dd2aa1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd2aa1b",
  null
  
)

export default component.exports